import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialOrderFeedbackCollectionState } from './initialState'

const slice = createSlice({
  name: 'orderFeedbackCollection',
  initialState: initialOrderFeedbackCollectionState,
  reducers: {
    setAllowWrittenFeedbackCollection: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.allowWrittenFeedbackCollection = action.payload
    },
    resetForm: (
      state,
      action: PayloadAction<{
        allowWrittenFeedbackCollection: boolean
      }>
    ) => {
      state.allowWrittenFeedbackCollection =
        action.payload.allowWrittenFeedbackCollection
      state.persistedAllowWrittenFeedbackCollection =
        action.payload.allowWrittenFeedbackCollection
    },
    // Marks the current edit as saved. Called after a successful PATCH, which
    // makes the pane clean again and disables Publish until the next change.
    markFormPersisted: state => {
      state.persistedAllowWrittenFeedbackCollection =
        state.allowWrittenFeedbackCollection
    },
    setFormSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isFormSubmitting = action.payload
    },
  },
})

export const reducer = slice.reducer
export const {
  setFormSubmitting,
  setAllowWrittenFeedbackCollection,
  resetForm,
  markFormPersisted,
} = slice.actions
